;(function () {
	const initMegaSubmenu = (header) => {
		const megaSubmenuLinks = header.querySelectorAll(
			'.list-menu--megasubmenu'
		)
		if (!megaSubmenuLinks || !megaSubmenuLinks.length) return
		megaSubmenuLinks.forEach((link) => {
			const tabs = link.querySelectorAll('.mega-submenu__tab')
			const submenus = link.querySelectorAll('.mega-submenu__submenu')
			const onToggle = (event) => {
				const tab = event.target
				if (!tab || !tab.classList.contains('mega-submenu__tab')) return
				const tabId = tab.dataset.tabId
				tabs.forEach((tab) => {
					tab.classList.remove('active')
				})
				tab.classList.add('active')
				submenus.forEach((submenu) => {
					submenu.classList.remove('active')
					if (submenu.dataset.tabId === tabId) {
						submenu.classList.add('active')
					}
				})
			}
			tabs.forEach((tab) => {
				tab.addEventListener('click', onToggle)
				tab.addEventListener('mouseenter', onToggle)
			})
		})
	}

	const header = () => {
		const header = document.querySelector('.shopify-section-header')
		const menu = document.querySelector('.list-menu--inline')
		const menuLinks = document.querySelectorAll('.list-menu-item')
		const search = document.querySelector('.header__search')

		header.addEventListener('keydown', (e) => {
			if (e.code === 'Escape' && search.isOpen) {
				search.close()
			}
		})

		let vh = window.innerHeight * 0.01
		document.documentElement.style.setProperty('--vh', `${vh}px`)

		const annBar = document.querySelector('.section-announcement')
		const annBarObserver = new IntersectionObserver((entries) => {
			const [entry] = entries

			if (entry.isIntersecting) {
				document.documentElement.style.setProperty(
					'--ann-height',
					`${entry.intersectionRect.height}px`,
				)
			} else {
				document.documentElement.style.setProperty('--ann-height', `0px`)
			}
		})
		if (annBar) annBarObserver.observe(annBar)

		/* willem. hover-intent voor het uitklapmenu.
		   1) Er staat al een paneel open en de muis komt over een ander
		      menu-item: dat paneel opent pas na een korte pauze. Wie langs
		      "Het Atelier" veegt op weg naar "Kunstenaars" krijgt dus niet
		      onderweg het paneel van "Het Atelier" te zien.
		   2) De muis gaat binnen een open paneel omlaag door lege ruimte
		      waar geen link meer onder ligt: dan klapt het paneel dicht,
		      want de bezoeker is onderweg naar de pagina eronder. */
		const WILLEM_HOVER = {
			switchDelay: 220,
			exitDrop: 40,
			aimDrop: 150,
			corridor: 28,
		}

		let openItem = null
		let switchTimer = null
		let dropAccum = 0
		let sideAccum = 0
		let lastPoint = null
		let panelLinkRects = []

		const isMegaItem = (item) => item.classList.contains('list-menu--megamenu')

		const panelOf = (item) =>
			item.querySelector('.header__mega-menu, .header__mega-submenu, .header__submenu')

		const clearSwitch = () => {
			clearTimeout(switchTimer)
			switchTimer = null
		}

		const resetAim = () => {
			dropAccum = 0
			sideAccum = 0
			lastPoint = null
		}

		const cachePanelLinks = (item) => {
			const panel = panelOf(item)
			panelLinkRects = panel
				? Array.prototype.slice
						.call(panel.querySelectorAll('a, button, input, select, textarea, summary'))
						.filter((el) => el.offsetParent !== null)
						.map((el) => el.getBoundingClientRect())
				: []
		}

		const closeAllPanels = () => {
			menuLinks.forEach((el) => {
				el.classList.remove('list-menu--megamenu-visible')
			})
			openItem = null
			resetAim()
		}

		const openPanel = (item) => {
			if (item.classList.contains('list-menu--tabs')) {
				const megaMenu = item.querySelector('.mega-menu') || item.querySelector('.mega-submenu')
				const headerMain = header.querySelector('.header')
				if (!megaMenu || !headerMain) return
				megaMenu.style.left = `${item.getBoundingClientRect().x}px`
			}
			item.classList.add('list-menu--megamenu-visible')
			if (
				header.classList.contains('color-background-3') &&
				!header.classList.contains('shopify-section-header-sticky')
			) {
				header.classList.remove('color-background-3')
			}
			menuLinks.forEach((el) => {
				if (el !== item) {
					el.classList.remove('list-menu--megamenu-visible')
				}
			})
			openItem = item
			resetAim()
			cachePanelLinks(item)
		}

		menuLinks.forEach((item) => {
			item.addEventListener('mouseenter', () => {
				clearSwitch()
				if (!isMegaItem(item)) {
					if (openItem) {
						switchTimer = setTimeout(closeAllPanels, WILLEM_HOVER.switchDelay)
					}
					return
				}
				if (item === openItem) {
					resetAim()
					return
				}
				if (!openItem) {
					openPanel(item)
					return
				}
				switchTimer = setTimeout(() => openPanel(item), WILLEM_HOVER.switchDelay)
			})
			item.addEventListener('mouseleave', clearSwitch)
		})

		menu.addEventListener('mousemove', (e) => {
			if (!openItem) return
			const panel = panelOf(openItem)
			if (!panel || !panel.contains(e.target)) {
				resetAim()
				return
			}
			if (e.target.closest('a, button, input, select, textarea, summary, [role="button"]')) {
				resetAim()
				return
			}

			const x = e.clientX
			const y = e.clientY
			if (!lastPoint) {
				lastPoint = { x: x, y: y }
				return
			}
			const dx = x - lastPoint.x
			const dy = y - lastPoint.y
			lastPoint = { x: x, y: y }
			if (dy <= 0) {
				dropAccum = 0
				sideAccum = 0
				return
			}
			dropAccum += dy
			sideAccum += Math.abs(dx)

			const corridor = WILLEM_HOVER.corridor
			const targetBelow = panelLinkRects.some(
				(r) => r.top >= y - 4 && r.right >= x - corridor && r.left <= x + corridor,
			)
			const limit = targetBelow ? WILLEM_HOVER.aimDrop : WILLEM_HOVER.exitDrop
			if (dropAccum >= limit && dropAccum >= sideAccum) {
				closeAllPanels()
			}
		})

		menu.addEventListener('mouseleave', () => {
			clearSwitch()
			closeAllPanels()
		})

		header.addEventListener('keydown', (e) => {
			if (e.key === 'Escape') {
				clearSwitch()
				closeAllPanels()
			}
		})

		window.addEventListener(
			'wheel',
			(e) => {
				if (openItem && e.deltaY > 0) {
					clearSwitch()
					closeAllPanels()
				}
			},
			{ passive: true },
		)

		document.body.addEventListener('mousedown', function () {
			document.body.classList.add('mouse-focus')
		})

		document.body.addEventListener('keydown', function (e) {
			if (e.key === 'Tab') {
				document.body.classList.remove('mouse-focus')
			}
		})

		const addBackground = () => {
			const headerObserver = new ResizeObserver((entries) => {
				const [entry] = entries
				if (entry.contentRect.width >= 1200) {
					if (
						header.classList.contains('color-background-3') &&
						!header.classList.contains('shopify-section-header-sticky')
					) {
						header.classList.remove('color-background-3')
					}
				}
			})

			headerObserver.observe(header)
		}

		const removeBackground = () => {
			const headerObserver = new ResizeObserver((entries) => {
				const [entry] = entries
				if (entry.contentRect.width >= 1200) {
					if (
						header.classList.contains('color-background-1') &&
						!header.classList.contains('shopify-section-header-sticky')
					) {
						header.classList.add('color-background-3')
					}
				}
			})

			headerObserver.observe(header)
		}

		header.addEventListener('mouseenter', addBackground)

		header.addEventListener('focus', addBackground)

		header.addEventListener('focusin', addBackground)

		header.addEventListener('mouseleave', removeBackground)

		header.addEventListener('focusout', removeBackground)

		const megaMenuListLinks = () => {
			const megaMenuLinkWithSubmenu = document.querySelector('.mega-menu__list-item--children')
			const megaMenuLinks = document.querySelectorAll('.mega-menu__list-item')
			if (megaMenuLinkWithSubmenu) {
				megaMenuLinks.forEach((link) => {
					link.classList.add('mega-menu__list-item--opacity')
				})
				megaMenuLinkWithSubmenu.classList.remove('mega-menu__list-item--opacity')
				megaMenuLinkWithSubmenu.classList.add('mega-menu__list-item--visible')
			}
			$('.mega-menu__list-item').mouseenter(function (event) {
				if (megaMenuLinkWithSubmenu) {
					megaMenuLinkWithSubmenu.classList.remove('mega-menu__list-item--visible')
				}
				$(this).removeClass('mega-menu__list-item--opacity')
				$(this).siblings().addClass('mega-menu__list-item--opacity')
				$(this).mouseleave(() => {
					$(this).siblings().removeClass('mega-menu__list-item--opacity')
				})
			})
			$('.mega-menu__list-item').focus(function (event) {
				if (megaMenuLinkWithSubmenu) {
					megaMenuLinkWithSubmenu.classList.remove('mega-menu__list-item--visible')
				}
				$(this).removeClass('mega-menu__list-item--opacity')
				$(this).siblings().addClass('mega-menu__list-item--opacity')
				$(this).mouseleave(() => {
					$(this).siblings().removeClass('mega-menu__list-item--opacity')
				})
			})
		}

		const megaMenuSublinks = () => {
			$('.mega-menu--list .mega-menu__submenu-item').mouseenter(function (event) {
				$(this).removeClass('mega-menu__submenu-item--opacity')
				$(this)
					.parent()
					.siblings()
					.find('.mega-menu__submenu-item')
					.addClass('mega-menu__submenu-item--opacity')
				$(this).mouseleave(() => {
					$(this)
						.parent()
						.siblings()
						.find('.mega-menu__submenu-item')
						.removeClass('mega-menu__submenu-item--opacity')
				})
			})
			$('.mega-menu--list .mega-menu__submenu-item').focusin(function (event) {
				$(this).removeClass('mega-menu__submenu-item--opacity')
				$(this)
					.parent()
					.siblings()
					.find('.mega-menu__submenu-item')
					.addClass('mega-menu__submenu-item--opacity')
				$(this).focusout(() => {
					$(this)
						.parent()
						.siblings()
						.find('.mega-menu__submenu-item')
						.removeClass('mega-menu__submenu-item--opacity')
				})
			})
		}

		const megaMenuTabs = () => {
			$('.mega-menu__tab-wrapper')
				.children()
				.find('.mega-menu__tab-wrapper')
				.first()
				.addClass('mega-menu__tab-wrapper--active')
			$('.mega-menu__tab-wrapper').mouseenter(function (event) {
				$('.mega-menu__tab-wrapper').removeClass('mega-menu__tab-wrapper--active')
				$(this).addClass('mega-menu__tab-wrapper--active')
			})
			$('.mega-menu__tab-wrapper').focus(function (event) {
				$('.mega-menu__tab-wrapper').removeClass('mega-menu__tab-wrapper--active')
				$(this).addClass('mega-menu__tab-wrapper--active')
			})
			$('.mega-menu__tab-wrapper').focusin(function (event) {
				$('.mega-menu__tab-wrapper').removeClass('mega-menu__tab-wrapper--active')
				$(this).addClass('mega-menu__tab-wrapper--active')
			})
		}

		megaMenuListLinks()
		megaMenuSublinks()
		megaMenuTabs()

		const main = document.querySelector('main')
		const breadcrumbs = document.querySelector('.breadcrumbs-wrapper')
		if (
			main.querySelectorAll('.shopify-section')[0]?.classList.contains('section--has-overlay') &&
			!main.querySelectorAll('.shopify-section')[0]?.classList.contains('not-margin')
		) {
			header.classList.add('color-background-1', 'color-background-3')
			if (breadcrumbs) {
				breadcrumbs.classList.add('color-background-3')
			}
		}

		initMegaSubmenu(header);
	}

	header()

	document.addEventListener('shopify:section:load', header)
	document.addEventListener('shopify:section:unload', header)
	document.addEventListener('shopify:section:reorder', header)
})()
